<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-12">
            <h1>Session Logs</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Session Logs</li>
            </ol>
          </div>
        </div>
      </div>
      <!-- /.container-fluid -->
    </section>

    <section class="content" v-if="has_permission === true">
      <div class="container-fluid">
        <div class="card">
          <div
            class="card-header py-3"
            v-if="!_.isEmpty(list.data) && is_loading == false"
          >
            <div class="btn-toolbar pull-right">
              <button
                class="btn btn-info"
                type="button"
                @click="showFilter = !showFilter"
              >
                <i class="fa fa-filter"></i> Filter
              </button>
            </div>

            <div class="card-tools">
              <button class="btn btn-outline" @click="exportFile()">
                <i class="icon-download"></i> Export
              </button>
            </div>
          </div>
          <div class="overlay" v-if="is_loading">
            <img src="/assets/images/loader.svg" alt="" />
          </div>
          <form @submit.prevent="getFilterData()" method="GET" novalidate>
            <div class="card-body" v-if="showFilter">
              <div class="form-row">
                <div class="col-md-6">
                  <!-- Device Name -->
                  <div v-if="organizationId == 1" class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="audraname"
                      >Device Name</label
                    >
                    <div class="col-md-9">
                      <div class="input-group">
                        <multiselect
                          v-model="filter.tableName"
                          :options="Object.keys(pre.deviceNames)"
                          :custom-label="(opt) => pre.deviceNames[opt]"
                          placeholder="Select Device"
                          :searchable="true"
                          :multiple="false"
                          id="tableName"
                          v-bind:class="{
                            'has-error': errors.has('tableName'),
                          }"
                          name="tableName"
                        >
                        </multiselect>
                      </div>
                    </div>
                  </div>

                  <!-- Protocol -->
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="audraname"
                      >Protocol</label
                    >
                    <div class="col-md-9">
                      <div class="input-group">
                        <multiselect
                          v-model="filter.protocol"
                          :options="Object.keys(pre.protocols)"
                          :custom-label="(opt) => pre.protocols[opt]"
                          placeholder="Select Protocol"
                          :searchable="true"
                          :multiple="false"
                          id="protocol"
                          v-bind:class="{
                            'has-error': errors.has('protocol'),
                          }"
                          name="protocol"
                        >
                        </multiselect>
                      </div>
                    </div>
                  </div>

                  <!-- Src IP -->
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="source_ip">Src IP</label>
                    <div class="col-md-9">
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text">
                            <i class="fas fa-pencil-alt"></i>
                          </span>
                        </div>
                        <input
                          autocomplete="off"
                          type="text"
                          id="source_ip"
                          name="source_ip"
                          v-model="filter.source_ip"
                          :class="{
                            'has-error': errors.has('source_ip'),
                          }"
                          class="form-control"
                          placeholder="Src IP"
                        />
                      </div>
                    </div>
                  </div>

                  <!-- Dest IP -->
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="destination_ip"
                      >Dst IP</label
                    >
                    <div class="col-md-9">
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text">
                            <i class="fas fa-pencil-alt"></i>
                          </span>
                        </div>
                        <input
                          autocomplete="off"
                          type="text"
                          id="destination_ip"
                          name="destination_ip"
                          v-model="filter.destination_ip"
                          :class="{
                            'has-error': errors.has('destination_ip'),
                          }"
                          class="form-control"
                          placeholder="Dst IP"
                        />
                      </div>
                    </div>
                  </div>

                  <!-- Src Port -->
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="source_port"
                      >Src Port</label
                    >
                    <div class="col-md-9">
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text">
                            <i class="fas fa-pencil-alt"></i>
                          </span>
                        </div>
                        <input
                          autocomplete="off"
                          type="text"
                          id="source_port"
                          name="source_port"
                          v-model="filter.source_port"
                          :class="{
                            'has-error': errors.has('source_port'),
                          }"
                          class="form-control"
                          placeholder="Src Port"
                        />
                      </div>
                    </div>
                  </div>

                  <!-- Dest Port -->
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="destination_port"
                      >Dst Port</label
                    >
                    <div class="col-md-9">
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text">
                            <i class="fas fa-pencil-alt"></i>
                          </span>
                        </div>
                        <input
                          autocomplete="off"
                          type="text"
                          id="destination_port"
                          name="destination_port"
                          v-model="filter.destination_port"
                          :class="{
                            'has-error': errors.has('destination_port'),
                          }"
                          class="form-control"
                          placeholder="Dst Port"
                        />
                      </div>
                    </div>
                  </div>

                  <!--  Time -->
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="time">Time Range</label>
                    <div class="col-md-9">
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text">
                            <i class="fas fa-calendar"></i>
                          </span>
                        </div>
                        <input
                          autocomplete="off"
                          type="datetime-local"
                          id="from_time"
                          name="from_time"
                          v-model="filter.from_time"
                          :class="{
                            'has-error': errors.has('from_time'),
                          }"
                          class="form-control"
                          placeholder="Time"
                        />

                        <span class="input-group-text"> - </span>

                        <input
                          autocomplete="off"
                          type="datetime-local"
                          id="to_time"
                          name="to_time"
                          v-model="filter.to_time"
                          :class="{
                            'has-error': errors.has('to_time'),
                          }"
                          class="form-control"
                          placeholder="Time"
                        />
                      </div>

                      <div class="help text-danger">
                        {{ timeError }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-9">
                      <button type="submit" class="btn btn-common m-2px">
                        <i class="fas fa-search"></i> Search
                      </button>
                      <button type="reset" class="btn btn-warning" @click="resetFilter()">
                        <i class="fas fa-undo"></i> Reset
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <template>
            <div class="card-body">
              <div v-if="!_.isEmpty(list.data) && !is_loading">
                <div class="d-flex justify-content-between align-items-center mb-3"></div>
                <div class="table-responsive-md">
                  <table class="table">
                    <thead>
                      <tr>
                        <th>Src IP</th>
                        <th>Dst IP</th>
                        <th>NAT IP</th>
                        <th>Start Time</th>
                        <th>End Time</th>
                        <th>Protocol</th>
                        <th>Src Port</th>
                        <th>Dst Port</th>
                        <th>Upload</th>
                        <th>Download</th>
                      </tr>
                    </thead>
                    <tbody class="list">
                      <tr v-for="(val, index) in list.data" :key="index">
                        <td>{{ val.source_ip }}</td>
                        <td>{{ val.destination_ip }}</td>
                        <td>{{ val.nat_ip }}</td>
                        <td>{{ val.start_time }}</td>
                        <td>{{ val.last_update_time }}</td>
                        <td>{{ val.protocol == 6 ? "TCP" : "UDP" }}</td>
                        <td>{{ val.source_port }}</td>
                        <td>{{ val.destination_port }}</td>
                        <td>{{ processUpload(val.upload) }}</td>
                        <td>{{ processDownload(val.download) }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="mt-2 text-right d-block d-sm-none">
                  Swipe <i class="icon-swipe"></i>
                </div>
              </div>
              <div class="p-4" v-if="_.isEmpty(list.data) && !is_loading">
                <div class="no-data">
                  <img src="/assets/images/no-data.svg" alt="" />
                  <h3>No data found!</h3>
                </div>
              </div>
            </div>
            <div :class="{ 'card-footer': list.total > list.per_page }">
              <div>Showing {{ showingText }}</div>
              <vue-pagination
                :pagination="list"
                v-if="list.total > list.per_page"
                @paginate="reload"
              ></vue-pagination>
            </div>
          </template>
        </div>
      </div>
    </section>

    <section class="content" v-if="has_permission === false">
      <div class="alert alert-danger alert-dismissible">
        <h5><i class="icon fas fa-ban"></i> Permission denied!</h5>
      </div>
    </section>
  </div>
</template>

<script>
import VuePagination from "@/components/partials/PaginationComponent";
import SortIcons from "@/components/utils/SortIcons";
import { CommonAPI, PermissionChecker } from "@/services/api";
import LocalStorage from "@/services/localStorage";
import axios from "axios";
import { Notification } from "element-ui";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { mapGetters } from "vuex";
// eslint-disable-next-line @typescript-eslint/no-var-requires
// const fileDownload = require("js-file-download");
import { fileDownload } from "@/utils/CommonUtils";

export default {
  name: "SessionLog",
  metaInfo: {
    title: "Session Logs | Dotlines",
  },
  components: {
    DatePicker,
    VuePagination,
    SortIcons,
  },
  data() {
    return {
      organizationId: LocalStorage.get("organizationId"),
      list: {
        data: [],
        total: 0,
        per_page: 10, // Default page limit
        from: 1,
        to: 0,
        current_page: 1,
      },
      perPage: 10, // Default page limit
      actionCreate: false,
      actionView: true,
      actionEdit: true,
      actionDelete: true,
      api_url: "",
      showFilter: false,
      filter: {},
      dateRange: "",
      pre: {
        deviceNames: {},
        protocols: { 6: "TCP", 17: "UDP" },
        deviceInfos: [],
      },
      is_loading: false,
      empty: false,
      empty_message: "",
      custom_permission_data: [],
      has_permission: true,
      audraName: "",
      tableName: "",
      timeError: "",
    };
  },
  watch: {
    "$route.query"() {
      this.reload();
    },
  },
  mounted() {
    if (this.isMobile()) {
      window.$(document).find(".push-menu-class").trigger("click");
    }
    this.api_url = "/session_logs";
    this.initialize();
  },
  computed: {
    ...mapGetters(["profile"]),
    showingText() {
      const start = (this.list.current_page - 1) * this.list.per_page + 1;
      const end = Math.min(this.list.current_page * this.list.per_page, this.list.total);
      return `${start} to ${end} of ${this.list.total} entries`;
    },
  },
  methods: {
    async initialize() {
      this.is_loading = true;
      const _this = this;

      if (_.isEmpty(this.profile)) {
        await CommonAPI.getProfile().then((profile_info) => {
          this.user_detail = profile_info;
        });
      } else {
        this.user_detail = this.profile;
      }

      // await CommonAPI.getCustomPermission(
      //   "/get-custom-permission-infos?path=api/session_logs"
      // ).then((response) => {
      //   if (response.status == 200) {
      //     this.custom_permission_data = response.data;
      //   }
      // });

      // if (!_.isEmpty(this.custom_permission_data)) {
      //   this.actionCreate = await PermissionChecker.checkCreateButtonPermission(
      //     this.custom_permission_data.action_permission,
      //     this.custom_permission_data["create_id_condition"],
      //     this.user_detail,
      //     this.custom_permission_data.enableAdministratorPermissionByDefault
      //   );
      // }

      await this.getList()
        .then((response) => {
          this.list = response.data;
        })
        .catch((error) => {
          this.empty = true;
          if (error.response.status === 403) {
            this.has_permission = false;
          }
        });

      await this.getDeviceInfos()
        .then((response) => {
          _this.pre.deviceInfos = response.data;
          _this.setDeviceNames();
          _this.setAudraName();
        })
        .catch((error) => {
          console.log(error.response);
        });

      this.is_loading = false;
    },
    async getFilterData() {
      this.list.current_page = 1;
      this.is_loading = true;
      this.tableName = this.filter.tableName ? this.filter.tableName : this.tableName;

      if (this.validateFilterData()) {
        await this.getList()
          .then((response) => {
            this.list = response.data;
            this.setAudraName();
          })
          .catch((error) => {
            this.empty = true;
            if (error.response.status === 403) {
              this.has_permission = false;
            }
          });
      }

      this.is_loading = false;
      this.$router.push({ path: this.$route.fullPath, query: {} }).catch(() => {});
    },
    reload() {
      this.is_loading = true;

      this.getList()
        .then((response) => {
          this.list = response.data;
        })
        .catch((error) => {
          this.empty = true;
          if (error.response.status === 403) {
            this.has_permission = false;
          }
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
    getList() {
      return new Promise((resolve, reject) => {
        let params = {
          ...this.filter,
          userAccountId: LocalStorage.get("accountId"),
          ...this.$route.query,
          page: this.list.current_page,
        };

        if (this.tableName) {
          params["tableName"] = this.tableName;
        }

        axios
          .get(this.api_url, { params })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    checkEditPermission(data) {
      if (!_.isEmpty(this.custom_permission_data)) {
        return PermissionChecker.checkEditButtonPermission(
          this.custom_permission_data.action_permission,
          this.custom_permission_data["edit_id_condition"],
          this.custom_permission_data["edit_refid_condition"],
          this.custom_permission_data["edit_custom_condition"],
          data,
          this.user_detail,
          this.custom_permission_data.enableAdministratorPermissionByDefault,
          this.custom_permission_data["operator_between_block_condition_rules"]
        );
      } else {
        return false;
      }
    },
    checkDeletePermission(data) {
      if (!_.isEmpty(this.custom_permission_data)) {
        return PermissionChecker.checkDeleteButtonPermission(
          this.custom_permission_data.action_permission,
          this.custom_permission_data["delete_id_condition"],
          this.custom_permission_data["delete_refid_condition"],
          this.custom_permission_data["delete_custom_condition"],
          data,
          this.user_detail,
          this.custom_permission_data.enableAdministratorPermissionByDefault,
          this.custom_permission_data["operator_between_block_condition_rules"]
        );
      } else {
        return false;
      }
    },
    async resetFilter() {
      this.list.current_page = 1;
      this.filter = {};
      this.is_loading = true;
      await this.getList()
        .then((response) => {
          this.list = response.data;
        })
        .catch((error) => {
          this.empty = true;

          if (error.response.status === 403) {
            this.has_permission = false;
          }
        });
      this.is_loading = false;
      this.$router.push({ path: this.$route.path }).catch(() => {});
    },
    exportFile() {
      this.is_loading = true;
      const params = {
        userAccountId: LocalStorage.get("accountId"),
        tableName: this.tableName,
      };
      axios
        .get("/session_logs-export", {
          params,
          responseType: "blob",
        })
        .then((response) => {
          fileDownload(response.data, "session_logs.xlsx");
        })
        .catch((error) => {
          console.log("error " + error);
        })
        .finally(() => {
          this.is_loading = false;
          Notification.success({
            title: "Export Completed",
            message: "Export operation completed successfully",
            type: "success",
          });
        });
    },
    processUpload(upload) {
      if (!upload) return "0 B";

      let updateUpload = upload + " B";
      if (upload >= 1024) updateUpload = (upload / 1024).toFixed(2) + " KB";
      if (upload >= 1024 * 1024)
        updateUpload = (upload / (1024 * 1024)).toFixed(2) + " MB";
      if (upload >= 1024 * 1024 * 1024)
        updateUpload = (upload / (1024 * 1024 * 1024)).toFixed(2) + " GB";

      return updateUpload;
    },
    processDownload(download) {
      if (!download) return "0 B";

      let updateDownload = download + " B";
      if (download >= 1024) updateDownload = (download / 1024).toFixed(2) + " KB";
      if (download >= 1024 * 1024)
        updateDownload = (download / (1024 * 1024)).toFixed(2) + " MB";
      if (download >= 1024 * 1024 * 1024)
        updateDownload = (download / (1024 * 1024 * 1024)).toFixed(2) + " GB";

      return updateDownload;
    },
    getDeviceInfos() {
      return new Promise((resolve, reject) => {
        const params = {
          accountId: LocalStorage.get("accountId"),
        };
        axios
          .get("/get-device-infos", { params })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    setDeviceNames() {
      for (let i = 0; i < this.pre.deviceInfos.length; i++) {
        this.pre.deviceNames[this.pre.deviceInfos[i].session_name] = this.pre.deviceInfos[
          i
        ].device_name;
      }
      console.log("device names");
      console.log(this.pre.deviceNames);
    },
    setAudraName() {
      const _this = this;
      let deviceInfo;
      if (this.tableName) {
        deviceInfo = this.pre.deviceInfos.find(
          (item) => item.session_name == _this.tableName
        );
      } else {
        deviceInfo = this.pre.deviceInfos.find(
          (item) => item.id == LocalStorage.get("accountId")
        );
      }

      this.audraName = deviceInfo.device_name;
      this.tableName = deviceInfo.session_name;
    },
    validateFilterData() {
      if (!this.filter.from_time && !this.filter.to_time) {
        this.timeError = "";
        return true;
      } else if (this.filter.from_time && !this.filter.to_time) {
        this.timeError = "One of the time field is empty";
        return false;
      } else if (!this.filter.from_time && this.filter.to_time) {
        this.timeError = "One of the time field is empty";
        return false;
      } else if (new Date(this.filter.from_time) > new Date(this.filter.to_time)) {
        this.timeError = "Invalid time range";
        return false;
      } else {
        this.timeError = "";
        return true;
      }
    },
    updatePageLimit() {
      this.list.per_page = this.perPage;
      this.list.current_page = 1;
      this.reload();
    },
  },
};
</script>
